import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';

const MultipleLinesTextComponent = ({ properties = {}, id, value, valueUpdaterCallback, validityUpdaterCallback }) => {
    const { options = {}, constrains = {} } = properties;
    const { required = false, label = "Multiline Text" } = options;
    const { minLength, maxLength, minRows = 3, maxRows } = constrains;

    const [textValue, setTextValue] = useState(value || '');
    const [error, setError] = useState(false);
    const [helperText, setHelperText] = useState('');

    // Sync with parent value
    useEffect(() => {
        if (value !== undefined && value !== textValue) {
            setTextValue(value);
        }
    }, [value]);

    // Validate the text
    const validate = (text) => {
        let isValid = true;
        let errorMessage = '';

        if (required && (!text || text.trim() === '')) {
            isValid = false;
            errorMessage = 'This field is required';
        } else if (minLength && text.length < minLength) {
            isValid = false;
            errorMessage = `Minimum ${minLength} characters required`;
        } else if (maxLength && text.length > maxLength) {
            isValid = false;
            errorMessage = `Maximum ${maxLength} characters allowed`;
        }

        setError(!isValid);
        setHelperText(errorMessage);

        if (validityUpdaterCallback) {
            validityUpdaterCallback(isValid);
        }

        return isValid;
    };

    const handleChange = (e) => {
        const newValue = e.target.value;
        setTextValue(newValue);
        validate(newValue);

        if (valueUpdaterCallback) {
            valueUpdaterCallback(newValue);
        }
    };

    return (
        <TextField
            id={id}
            label={label}
            multiline
            rows={minRows}
            maxRows={maxRows}
            value={textValue}
            onChange={handleChange}
            required={required}
            error={error}
            helperText={helperText || (maxLength ? `${textValue.length}/${maxLength} characters` : '')}
            fullWidth
            variant="outlined"
            inputProps={{
                maxLength: maxLength,
            }}
            sx={{ width: '100%', maxWidth: '100%' }}
        />
    );
};

export default MultipleLinesTextComponent;
